/**
 * 登録用データ管理
 *
 * @format
 */

class DataStore {
  constructor(list, keyName) {
    this.data = list.reduce((a, item) => {
      a[item[keyName]] = {
        id: item[keyName],
        memo: item.memo,
        checked: true,
      };
      return a;
    }, {});
  }

  update({ id, memo, checked }) {
    if (typeof id === "undefined") {
      return;
    }
    if (typeof this.data[id] === "undefined") {
      this.data[id] = { id, memo: "", checked: true };
    }
    if (typeof memo !== "undefined") {
      this.data[id].memo = memo;
    }
    if (typeof checked !== "undefined") {
      this.data[id].checked = checked;
    }
  }

  isChecked(id) {
    return this.data[id] ? this.data[id].checked : false;
  }

  getMemo(id) {
    return this.data[id] ? this.data[id].memo : "";
  }

  getData() {
    return this.data;
  }

  isCheckedGroup() {
    return !!Object.values(this.data).find((e) => e.checked);
  }
}

class MediaStore extends DataStore {
  constructor(list) {
    super(list, "experienced_media_master_id");
  }

  getPostData(master) {
    let data = { experienced_medias: [] };
    for (const type of master) {
      for (const detail of type.list) {
        for (const media of detail.list) {
          if (this.data[media.id] && this.data[media.id].checked) {
            data.experienced_medias.push(media.id);
            if (media.type == "text") {
              data[`media_memo_${media.id}`] = this.data[media.id].memo;
            }
          }
        }
      }
    }
    return data;
  }
}

class ContentsStore extends DataStore {
  constructor(list) {
    super(list, "experienced_contents_master_id");
  }
  getPostData(master) {
    let data = { experienced_contents: [] };
    for (const type of master) {
      for (const contents of type.list) {
        if (this.data[contents.id] && this.data[contents.id].checked) {
          data.experienced_contents.push(contents.id);
          if (contents.type == "text") {
            data[`contents_memo_${contents.id}`] = this.data[contents.id].memo;
          }
        }
      }
    }
    return data;
  }
}

class SkillStore extends DataStore {
  constructor(list) {
    super(list, "work_skill_master_id");
  }
  getPostData(master) {
    let data = { work_skills: [] };
    for (const genre of master) {
      for (const skill of genre.list) {
        if (this.data[skill.id] && this.data[skill.id].checked) {
          data.work_skills.push(skill.id);
          if (skill.type == "text") {
            data[`work_skill_memo_${skill.id}`] = this.data[skill.id].memo;
          }
        }
      }
    }
    return data;
  }
}

class GenresStore extends DataStore {
  constructor(list) {
    super(list, "genre_master_id");
  }
  getPostData() {
    const genres = Object.entries(this.data).reduce((a, [id, item]) => {
      if (item.checked) {
        a.push(id);
      }
      return a;
    }, []);
    const genre_memo_other = Object.entries(this.data).reduce(
      (a, [id, item]) => (id == "42" && item.checked ? item.memo : a),
      ""
    );
    return { genres, genre_memo_other };
  }
}

export { MediaStore, ContentsStore, SkillStore, GenresStore };
